// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-close-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path
      fill='currentColor'
      d='M9.714 9.714a4.25 4.25 0 1 1 6.009 6.01 4.25 4.25 0 0 1-6.01-6.01zm.795.795a1 1 0 0 0 0 1.414l.796.796-.796.795a1 1 0 1 0 1.414 1.415l.796-.796.795.796a1 1 0 0 0 1.415-1.415l-.796-.795.795-.796a1 1 0 0 0-1.414-1.414l-.795.795-.796-.795a1 1 0 0 0-1.414 0z'
    />
    <path d='M1.031 12.719A4.784 4.784 0 0 1 7.69 8.32m-4.8-4.367a2.922 2.922 0 1 0 5.844 0 2.922 2.922 0 0 0-5.843 0z' />
  </g>
);

export const viewBox = '0 0 18 18';
